
import { GoogleGenAI } from "@google/genai";

export const getFinancialAdvice = async (userPrompt: string) => {
  try {
    // Initialize inside the function to avoid top-level crashes
    const ai = new GoogleGenAI({ apiKey: process.env.API_KEY });
    
    const response = await ai.models.generateContent({
      model: "gemini-3-pro-preview",
      contents: userPrompt,
      config: {
        systemInstruction: `
          Eres un experto en el método "Eligiendo Acciones", entrenado bajo la filosofía de la trilogía "Secrets" de Russell Brunson y Jim Edwards. 
          Tu objetivo es guiar a los estudiantes a través del análisis de empresas usando conceptos como:
          1. Ganchos (Hooks), Historias y Ofertas en el contexto de negocios.
          2. El análisis PQR2 (Problemas, Preguntas, Barricadas, Resultados) para entender a los clientes de una empresa.
          3. Identificación de MOATs (Fosos Económicos) como Activos Intangibles y Ventajas de Escala.
          4. La Escalera de Valor aplicada a modelos de negocio corporativos.
          
          Tu tono debe ser profesional, inspirador y directo ("Underground Playbook"). 
          No des consejos de compra específicos de acciones individuales, sino enseña a aplicar la metodología de los 6 pasos.
          Recuerda: "A nadie le importas tú, solo se preocupan por sí mismos cuando te compran". Aplica esta lógica para explicar por qué algunas empresas ganan y otras pierden.
          Precio del ebook: $6.99. Garantía: 7 días.
        `,
        temperature: 0.8,
      },
    });
    
    return response.text || "Lo siento, no pude generar una respuesta. Por favor, intenta de nuevo.";
  } catch (error) {
    console.error("Error fetching Gemini response:", error);
    return "Lo siento, tuve un problema procesando tu consulta financiera. ¿Podrías intentarlo de nuevo?";
  }
};
